/* eslint-disable check-window-access/check-window-access */
import { cloneWidget } from '@alfa-bank/site-util-create-widget/clone-widget';
import { Children, isValidElement } from 'react';
import { AUTH_ALFAID_INITIALIZE } from '@alfa-bank/site-envconfig';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { useIsClient } from '@alfa-bank/site-helpers-common/browser/use-is-client';

import type { IAlfaId } from './models';

export const AlfaId = ({ analytics, children }: IAlfaId) => {
    const isClient = useIsClient();
    const isValid = isValidElement(children);
    const props = isValid ? Children.only(children).props : null;
    const redirectHomeUrl = isClient ? window.location.href : '';
    const linkToAlfaId = `${AUTH_ALFAID_INITIALIZE()}?redirectUri=${redirectHomeUrl}`;

    const handleClick = () => sendEvent(analytics);

    return isValid
        ? cloneWidget(children, {
              ...props,
              href: linkToAlfaId,
              onClick: handleClick,
          })
        : null;
};
